import { provider } from "@grassrootly/api/providers";

export type GetPlayerTotalsPayload = {
  pid: number;
};

export type PlayerTotals = {
  player_id: number;
  total_goals_scored: number;
  total_assists_made: number;
  total_wins: number;
  total_draws: number;
  total_lost: number;
  total_experience_points: number;
  total_games: number;
};

export const GetPlayersTotals = async (
  params: GetPlayerTotalsPayload
): Promise<PlayerTotals | null> => provider.Request("/player-totals", params);
